<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Sao lưu dữ liệu toàn hệ thống</strong>
                    </div>
                    <b-form @submit.prevent="save">
                        <b-row>
                            <b-col md="9" offset-md="2">
                                <b-form-group label="Tần suất đồng bộ định kỳ"
                                              :label-cols="12"
                                              label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <select v-model="backupFrequency" class="form-control" required>
                                        <option value="1" selected>Hàng ngày</option>
                                        <option value="2">Hàng tuần</option>
                                        <option value="3">Hàng tháng</option>
                                    </select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="9" offset-md="2">
                                <b-form-group label="Thời điểm đồng bộ"
                                              :label-cols="12"
                                              label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input v-model="backupTime"></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="9">
                                <b-form-group label=""
                                              :label-cols-md="7">
                                    <b-button type="submit" variant="primary">Lưu</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mixins } from '@/shared/mixins'

    export default {
        name: 'BackupParameter',
        mixins: [mixins],
        data() {
            return {
                backupFrequency: null,
                backupTime: null
            }
        },
        created() {
            this.loadSytemParamter();
        },
        methods: {
            save() {
                var vm = this;
                this.$services.put('system-parameters/backup', { backupFrequency: this.backupFrequency, backupTime: this.backupTime }).done((response) => {
                    vm.$toastr.s('Cập nhật tham số sao lưu thành công');
                });
            },
            loadSytemParamter() {
                var vm = this;
                this.$services.get('system-parameters/backup').done((response) => {
                    vm.backupFrequency = response.backupFrequency;
                    vm.backupTime = response.backupTime;
                });
            }
        }
    }
</script>
<style scoped>
</style>
